export const theaterList = {
  "2D": {
    t1: {
      name: "Cinephile HSR Layout: PNR Felicity Mall Haralur Rd",
      timings: ["9:00AM", "01:30PM", "06:30PM", "09:45PM"],
      others: ["M-Ticket"],
      cancellable: true,
    },
    t2: {
      name: "Cinepolis: Lulu Mall, Bengaluru",
      timings: ["10:30AM", "11:30PM", "04:00PM", "06:45PM"],
      others: ["M-Ticket", "Food & Beverage"],
      cancellable: true,
    },
    t3: {
      name: "Abhinay Theatre 4K A/C: Gandhinagar",
      timings: ["07:45PM"],
      others: [],
      cancellable: false,
    },
    t4: {
      name: "Cinepolis: Royal Meenakshi Mall",
      timings: ["10:10PM"],
      others: ["M-Ticket", "Food & Beverage"],
      cancellable: false,
    },
    t5: {
      name: "Cinepolis: SJR (Central Mall) Arekere, Bannergatta",
      timings: ["10:30"],
      others: ["M-Ticket", "Food & Beverage"],
      cancellable: false,
    },
    t6: {
      name: "Gopalan Mall: Sirsi Circle",
      timings: ["02:30PM"],
      others: ["M-Ticket", "Food & Beverage"],
      cancellable: true,
    },
    t7: {
      name: "INOX Lido: Off MG Road, Ulsoor",
      timings: ["11:45PM", "01:30PM", "04:20PM", "10:45PM"],
      others: ["M-Ticket", "Food & Beverage"],
      cancellable: true,
    },
    t8: {
      name: "INOX: Central, JP Nagar, Mantri Junction",
      timings: ["9:30AM", "12:30PM", "6:30PM", "09:45PM"],
      others: ["M-Ticket", "Food & Beverage"],
      cancellable: false,
    },
    t9: {
      name: "INOX: Nexus, Whitefield",
      timings: ["09:30AM", "12:30PM", "03:55PM", "06:30PM", "09:45PM"],
      others: ["M-Ticket", "Food & Beverage"],
      cancellable: false,
    },
    t10: {
      name: "PVR: Nexus (Formerly Forum), Koramangala",
      timings: [
        "09:30AM",
        "12:30PM",
        "02:30PM",
        "04:45PM",
        "6:30PM",
        "09:45PM",
      ],
      others: ["M-Ticket", "Food & Beverage"],
      cancellable: true,
    },
  },
  "3D": {
    t1: {
      name: "Cinepolis VIP: Lulu Mall, Bengaluru",
      timings: ["9:00AM", "04:10PM", "06:30PM", "10:45PM"],
      others: ["M-Ticket"],
      cancellable: true,
    },
    t2: {
      name: "Cinepolis: Binnypet Mall",
      timings: ["10:30AM", "11:30PM", "06:45PM"],
      others: ["M-Ticket", "Food & Beverage"],
      cancellable: false,
    },
    t3: {
      name: "Cinepolis: Lulu Mall, Bengaluru",
      timings: ["02:25", "07:45PM"],
      others: ["M-Ticket", "Food & Beverage"],
      cancellable: true,
    },
    t4: {
      name: "PVR: Nexus (Formerly Forum), Koramangala ",
      timings: ["04:40", "10:10PM"],
      others: ["M-Ticket", "Food & Beverage"],
      cancellable: true,
    },
    t8: {
      name: "INOX Lido: Off MG Road, Ulsoor",
      timings: ["11:45PM", "01:30PM", "04:20PM", "10:45PM"],
      others: ["M-Ticket", "Food & Beverage"],
      cancellable: false,
    },
    t9: {
      name: "INOX: Central, JP Nagar, Mantri Junction",
      timings: ["9:30AM", "12:30PM", "6:30PM", "09:45PM"],
      others: ["M-Ticket", "Food & Beverage"],
      cancellable: false,
    },
    t10: {
      name: "PVR: Phoenix Marketcity Mall, Whitefield Road ",
      timings: ["09:30AM", "12:30PM", "03:55PM", "06:30PM", "09:45PM"],
      others: ["M-Ticket", "Food & Beverage"],
      cancellable: true,
    },
    t11: {
      name: "PVR: Orion Mall, Dr Rajkumar Road",
      timings: [
        "09:30AM",
        "12:30PM",
        "02:30PM",
        "04:45PM",
        "6:30PM",
        "09:45PM",
      ],
      others: ["M-Ticket", "Food & Beverage"],
      cancellable: true,
    },
  },
  "IMAX 2D": {
    t1: {
      name: "Cinepolis: Nexus Shantiniketan, Bengaluru",
      timings: ["9:00AM", "04:10PM", "06:30PM", "10:45PM"],
      others: ["M-Ticket", "Food & Beverage"],
      cancellable: false,
    },
    t2: {
      name: "INOX: Mantri Square, Malleshwaram",
      timings: ["10:30AM", "11:30PM", "06:45PM"],
      others: ["M-Ticket", "Food & Beverage"],
      cancellable: true,
    },
    t3: {
      name: "PVR: Nexus (Formerly Forum), Koramangala",
      timings: ["02:25", "07:45PM"],
      others: ["M-Ticket", "Food & Beverage"],
      cancellable: true,
    },
    t4: {
      name: "PVR: Vega City, Bannerghatta Road",
      timings: ["04:40", "10:10PM"],
      others: ["M-Ticket", "Food & Beverage"],
      cancellable: false,
    },
    t8: {
      name: "PVR: VR Bengaluru, Whitefield Road",
      timings: ["11:45PM", "01:30PM", "04:20PM", "10:45PM"],
      others: ["M-Ticket", "Food & Beverage"],
      cancellable: false,
    },
  },
  "IMAX 3D": {
    t1: {
      name: "Cinepolis: Nexus Shantiniketan, Bengaluru",
      timings: ["9:00AM", "04:10PM", "06:30PM", "10:45PM"],
      others: ["M-Ticket", "Food & Beverage"],
      cancellable: true,
    },
    t2: {
      name: "PVR: Bhartiya Mall of Bengaluru",
      timings: ["10:30AM", "11:30PM", "06:45PM"],
      others: ["M-Ticket", "Food & Beverage"],
      cancellable: true,
    },
    t3: {
      name: "PVR: Global Mall, Mysore Road, Bengaluru",
      timings: ["02:25", "07:45PM"],
      others: ["M-Ticket", "Food & Beverage"],
      cancellable: false,
    },
    t4: {
      name: "PVR: Nexus (Formerly Forum), Koramangala",
      timings: ["04:40", "10:10PM"],
      others: ["M-Ticket", "Food & Beverage"],
      cancellable: true,
    },
    t5: {
      name: "PVR: Phoenix Marketcity Mall, Whitefield Road",
      timings: ["11:45PM", "01:30PM", "04:20PM", "10:45PM"],
      others: ["M-Ticket", "Food & Beverage"],
      cancellable: false,
    },
  },
};
